module.exports = __webpack_public_path__ + "static/dancing-6994080740bf090d71cfcab50aff64ef.png";